import React, { useMemo } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import {
  getStaticCrudConnectLines,
  MY_CONNECT_LINE,
} from 'dialer/components/widgets/public/helpers/DialerSettings'

import styles from './NoConnectLineWarning.module.scss'

interface IProps {
  line: MY_CONNECT_LINE
  onChangeLine: (line: MY_CONNECT_LINE) => void
}

export const NoConnectLineWarning = ({ line, onChangeLine }: IProps) => {
  const source = useMemo(() => getStaticCrudConnectLines(), [])

  return (
    <div className={styles.container}>
      <div className={styles.warning}>Line is not provided for call.</div>
      <div className={styles.wrapper}>Please, select line:</div>
      <div className={styles.wrapper}>
        <Dropdown
          label="Line"
          caption="name"
          source={source}
          value={line}
          onChange={async (value: string) => {
            onChangeLine(value as MY_CONNECT_LINE)
          }}
          margin={'sm'}
        />
      </div>
    </div>
  )
}
